import React from 'react';
import { Signin, Signup } from '../components';
import { IndexView } from '../views';
import { useHomeContext } from '../context';

export default function Home() {
  const {
    showSignInBox,
    setShowSignInBox,
    showSignUpBox,
    setShowSignUpBox,
  } = useHomeContext();

  return (
    <>
      <IndexView />

      <Signin
        showSignInBox={showSignInBox}
        setShowSignInBox={setShowSignInBox}
        setShowSignUpBox={setShowSignUpBox}
      />

      <Signup
        showSignUpBox={showSignUpBox}
        setShowSignUpBox={setShowSignUpBox}
        setShowSignInBox={setShowSignInBox}
      />
    </>
  );
}
